import { useState } from 'react'
import { useTimeout } from '@mote/helpers'

export function useMemeTimeout(shouldShowMemeInitially: string): boolean {
  const [showMeme, setShowMeme] = useState<boolean>(
    Boolean(shouldShowMemeInitially)
  )

  useTimeout(
    () => {
      setShowMeme(false)
    },
    showMeme ? 2000 : null
  )

  return showMeme
}
